import type { SxProps, Theme } from '@mui/material/styles';
import { alpha } from '@mui/material/styles';
import { CHAT_MIN_WIDTH } from './utils/consts';
import type { ModalPosition, ModalSize } from './utils/types';
import { SIDE_PANEL_TRANSITION } from './utils/useSidePanelTransition';

export const getModalStyles = (position: ModalPosition, size: ModalSize, isInteractive: boolean): SxProps<Theme> => ({
  position: 'fixed',
  left: position.x,
  top: position.y,
  width: size.width,
  height: size.height,
  zIndex: 1401,
  backgroundColor: 'background.paper',
  borderRadius: '4px',
  boxShadow: '0px 12px 32px rgba(0, 0, 0, 0.12), 0px 4px 12px rgba(0, 0, 0, 0.08)',
  border: '1px solid',
  borderColor: 'divider',
  display: 'flex',
  flexDirection: 'column',
  overflow: 'hidden',
  boxSizing: 'border-box',
  transition: isInteractive ? 'none' : SIDE_PANEL_TRANSITION,
});

export const getChatContentStyles = (withSidePanel: boolean): SxProps<Theme> => ({
  width: withSidePanel ? `${CHAT_MIN_WIDTH}px` : '100%',
  flexShrink: 0,
  overflow: 'auto',
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  backgroundColor: 'background.paper',
});

export const SIDE_PANEL_STYLES: SxProps<Theme> = {
  flex: 1,
  minWidth: 0,
  overflow: 'auto',
  isolation: 'isolate',
  backgroundColor: 'background.boxDark',
  borderLeft: '1px solid',
  borderColor: 'divider',
};

export const getMenuOverlayStyles =
  (isMenuOpen: boolean): SxProps<Theme> =>
  (theme: Theme) => ({
    position: 'absolute',
    inset: 0,
    backgroundColor: alpha(theme.palette.text.primary, 0.2),
    opacity: isMenuOpen ? 1 : 0,
    transition: 'opacity 0.3s ease-in-out',
    pointerEvents: isMenuOpen ? 'auto' : 'none',
    zIndex: 1,
  });
